const priceChecker = (price, currency) => {
  let p = price.toString();
  if (p.indexOf(".") !== -1) {
    p = p.split(".");
    if (p[0] === "0") {
      let pence = p[1];
      if (pence[0] === "0") return `${pence[1]}${currency.minor}`;
      if (pence.length === 1) return `${pence}0${currency.minor}`;
      return `${pence}${currency.minor}`;
    }
    if (p[1] === "00") return `${currency.major}${p[0]}`;
    if (p[1].length === 1) return `${currency.major}${p[0]}.${p[1]}0`;
    if (p[1].length > 1) return `${currency.major}${p[0]}.${p[1]}`;
  }
  return `£${p}`;
};

const reset = {
  valueTileBottom: "",
  valueTileBottomFont: "",
  valueTileBackground: "#FFFFFF",
  valueTileColor: "#000000",
  strikethrough: false,
  clubcardPrice: false,
  percentSign: "",
  includeRegularPrice: false,
  newValueTile: false,
  vtWhite: true,
};

const clubcardPriceVt = {
  valueTileBottom: "",
  valueTileBottomFont: "",
  valueTileBackground: "#FCD700",
  valueTileColor: "#000000",
  strikethrough: false,
  clubcardPrice: true,
  percentSign: "",
};

//const toSave = (offer) => {
//  let s = offer.promotionDescription.split(" Was")[0];
//  if (s.indexOf(".00") !== -1) {
//    s = s.replace(".00", "");
//  }
//  if (s.indexOf("Save") !== -1) {
//    s = s.slice(s.indexOf("Save")).replace(".00", "");
//  }
//  const size = s.length > 8 ? "32px" : "40px";
//  return {
//    valueTileTop: s,
//    valueTileTopFont: size,
//    ...reset,
//  };
//};
//
//const toCcp = (offer) => {
//  let ccp = offer.slice(
//    offer.indexOf("Clubcard Price ") + 15,
//    offer.indexOf(". Offer")
//  );
//  if (ccp.indexOf(".00") !== -1) {
//    ccp = ccp.replace(".00", "");
//  }
//  let size;
//  switch (ccp.length) {
//    case 2:
//      size = "36px";
//      break;
//    case 3:
//      size = "32px";
//      break;
//    case 5:
//      size = "26px";
//      break;
//    case 6:
//      size = "22px";
//      break;
//    default:
//      size = "26px";
//  }
//  return {
//    valueTileTop: ccp,
//    valueTileTopFont: size,
//    ...clubcardPriceVt,
//  };
//};

//const toWas = (offer) => {
//  let s = offer.promotionDescription;
//  let was = s.slice(s.indexOf("Was") + 4, s.indexOf(" Now"));
//  if (was.indexOf(".00") !== -1) {
//    was = was.replace(".00", "");
//  }
//  if (was.indexOf("Then") !== -1) {
//    was = was.slice(0, was.indexOf("Then") - 1);
//  }
//  let now = s.slice(s.indexOf("Now") + 4);
//  if (now.indexOf(".00") !== -1) {
//    now = now.replace(".00", "");
//  }
//  if (now.indexOf("Save") !== -1) {
//    now = now.slice(0, now.indexOf("Save") - 1);
//  }
//  const size = now.length > 3 ? "32px" : now.length < 3 ? "52px" : "48px";
//  return {
//    valueTileTop: was,
//    valueTileTopFont: "20px",
//    strikethrough: true,
//    valueTileBottom: now,
//    valueTileBottomFont: size,
//    valueTileBackground: "#FCD700",
//    valueTileColor: "#000000",
//    clubcardPrice: false,
//    percentSign: "",
//  };
//};
//
//const toNew = () => {
//  return {
//    valueTileTop: "New",
//    valueTileTopFont: "40px",
//    valueTileBackground: "#00539F",
//    valueTileColor: "#FFFFFF",
//    valueTileBottom: "",
//    valueTileBottomFont: "",
//    strikethrough: false,
//    clubcardPrice: false,
//    percentSign: "",
//  };
//};
//
//const xFor = (offer, x) => {
//  let p = offer.promotionDescription.slice(
//    offer.promotionDescription.lastIndexOf("for") + 4
//  );
//  if (p.indexOf(".00") !== -1) {
//    p = p.replace(".00", "");
//  }
//  const size = p.length > 3 ? "32px" : "52px";
//  return {
//    bannerURL: `https://www.tesco.com/groceries/en-GB/promotions/${offer.promotionID}`,
//    valueTileTop: x,
//    valueTileTopFont: "20px",
//    valueTileBottom: p,
//    valueTileBottomFont: size,
//    valueTileBackground: "#FCD700",
//    valueTileColor: "#000000",
//    strikethrough: false,
//    clubcardPrice: false,
//    percentSign: "",
//  };
//};
//
//const xForX = (offer, x) => {
//  return {
//    bannerURL: `https://www.tesco.com/groceries/en-GB/promotions/${offer.promotionID}`,
//    valueTileTop: x,
//    valueTileTopFont: "24px",
//    ...reset,
//  };
//};

const priceCut = (offer) => {
  const { headline } = offer;
  let price = headline.split(" ")[0];
  if (price.indexOf(".00") !== -1) price = price.replace(".00", "");
  let size = price.length > 4 ? "28px" : price.length < 3 ? "48px" : "32px";
  return {
    valueTileTop: `${price}`,
    valueTileTopFont: size,
  };
};

const multiBuy = (offer) => {
  const { headline } = offer;
  let topText,
    topSize = "22px",
    bottomText,
    bottomSize = "22px";
  const arr = headline.split(" ");
  if (arr[0] === "Any") {
    topText = "Any";
    topSize = "16px";
    if (arr[3].indexOf(".00") !== -1) arr[3] = arr[3].replace(".00", "");
    bottomText = `${arr[1]} for ${arr[3]}`;
    bottomSize =
      arr[3].length > 4 ? "16px" : arr[3].length < 3 ? "22px" : "18px";
  } else {
    topText = `${arr[0]} ${arr[1]}`;
    if (arr[2].indexOf(".00") !== -1) arr[2] = arr[2].replace(".00", "");
    bottomText = arr[2];
  }
  let multiObj = {
    valueTileTop: topText,
    valueTileTopFont: topSize,
    valueTileBottom: bottomText,
    valueTileBottomFont: bottomSize,
  };
  if (headline.indexOf("Clubcard") !== -1) {
    multiObj = {
      ...multiObj,
      valueTileColor: "#000000",
      strikethrough: false,
      clubcardPrice: true,
      percentSign: "",
    };
  }
  return multiObj;
};

const valueTileOffer = async (offer) => {
  if (!offer) return null;
  //let size;
  let vtOffer;
  if (offer.qualities) {
    if (
      offer.qualities[0] === "multibuy" ||
      offer.qualities[1] === "multibuy"
    ) {
      return multiBuy(offer);
    }
    if (
      offer.qualities[0] === "price_cut" ||
      offer.qualities[1] === "price_cut"
    ) {
      vtOffer = await priceCut(offer);
    }
    if (offer.qualities[0].indexOf("Clubcard") !== -1) {
      vtOffer = { ...vtOffer, ...clubcardPriceVt, newValueTile: true };
    }
    return vtOffer;
  }
  return null;
  //switch (offer.icon) {
  //  case "halfprice":
  //    return {
  //      valueTileTop: "Half Price",
  //      valueTileTopFont: "32px",
  //      ...reset,
  //    };
  //  case "betterthanhalfprice":
  //    return {
  //      valueTileTop: "Better than",
  //      valueTileTopFont: "16px",
  //      valueTileBottom: "Half Price",
  //      valueTileBottomFont: "32px",
  //      valueTileBackground: "#FCD700",
  //      valueTileColor: "#000000",
  //      strikethrough: false,
  //    };
  //  case "specialoffer":
  //    let promo = offer.promotionDescription;
  //    promo = promo.toLowerCase();
  //    if (promo.indexOf("meal deal" !== -1)) {
  //      let headline = promo.slice(1, promo.lastIndexOf("for") - 1);
  //      headline = `${promo[0].toUpperCase()}${headline}`;
  //      p = promo.slice(promo.lastIndexOf("for £") + 4);
  //      size = p.length > 3 ? "32px" : "52px";
  //      return {
  //        valueTileTop: p,
  //        valueTileTopFont: size,
  //        valueTileBottom: "Meal deal",
  //        valueTileBottomFont: "20px",
  //        headline: headline,
  //        bannerURL: `https://www.tesco.com/groceries/en-GB/promotions/${offer.promotionID}`,
  //        valueTileBackground: "#FCD700",
  //        valueTileColor: "#000000",
  //        strikethrough: false,
  //      };
  //    } else {
  //      return null;
  //    }
  //  case "2for":
  //    return xFor(offer, "2 for");
  //  case "3for":
  //    return xFor(offer, "3 for");
  //  case "4for":
  //    return xFor(offer, "4 for");
  //  case "5for":
  //    return xFor(offer, "5 for");
  //  case "6for":
  //    return xFor(offer, "6 for");
  //  case "7for":
  //    return xFor(offer, "7 for");
  //  case "8for":
  //    return xFor(offer, "8 for");
  //  case "3for2":
  //    return xForX(offer, "3 for 2");
  //  case "4for3":
  //    return xForX(offer, "4 for 3");
  //  case "5for4":
  //    return xForX(offer, "5 for 4");
  //  case "25percentoff":
  //    return {
  //      bannerURL: `https://www.tesco.com/groceries/en-GB/promotions/${offer.promotionID}`,
  //      valueTileTop: "25% off",
  //      valueTileTopFont: "40px",
  //      ...reset,
  //    };
  //  case "save":
  //    p = offer.promotionDescription.split("Now ")[1];
  //    if (p.indexOf(".00") !== -1) {
  //      p = p.replace(".00", "");
  //    }
  //    if (p.indexOf("Save") !== -1) {
  //      p = p.slice(0, p.indexOf("Save") - 1);
  //    }
  //    size = p.length > 3 ? "32px" : "52px";
  //    return {
  //      valueTileTop: p,
  //      valueTileTopFont: size,
  //      ...reset,
  //    };
  //  case "only1pound":
  //    return {
  //      valueTileTop: "£1",
  //      valueTileTopFont: "52px",
  //      ...reset,
  //    };
  //  case "default":
  //    if (offer.promotionDescription.indexOf("Any") !== -1) {
  //      p = offer.promotionDescription.split(" ");
  //      if (p[3].indexOf(".00") !== -1) p[3] = p[3].replace(".00", "");
  //      size = p[3].length > 3 ? "32px" : "52px";
  //      return {
  //        bannerURL: `https://www.tesco.com/groceries/en-GB/promotions/${offer.promotionID}`,
  //        valueTileTop: `${p[1]} for`,
  //        valueTileTopFont: "20px",
  //        valueTileBottom: p[3],
  //        valueTileBottomFont: size,
  //        valueTileBackground: "#FCD700",
  //        valueTileColor: "#000000",
  //        strikethrough: false,
  //        clubcardPrice: false,
  //        percentSign: "",
  //        includeAsterisk: false,
  //        decimalPlace: "",
  //      };
  //    }
  //    break;
  //  case "buy1get1free":
  //    return {
  //      valueTileTop: "Buy 1 get 1",
  //      valueTileTopFont: "16px",
  //      valueTileBottom: "Free",
  //      valueTileBottomFont: "36px",
  //      valueTileBackground: "#FCD700",
  //      valueTileColor: "#000000",
  //      strikethrough: false,
  //      clubcardPrice: false,
  //      percentSign: "",
  //      includeAsterisk: false,
  //    };
  //  default:
  //    return null;
  //}
};

const getCurrency = (currency) => {
  const gbp = { major: "£", minor: "p" };
  const eur = { major: "€", minor: "c" };
  //return str.indexOf("EUR") !== -1 ? eur : gbp;
  return currency === "EUR" ? eur : gbp;
};

export const buildFastrade = async (data) => {
  const currency = getCurrency(data.currency);
  let offer = null;
  let price;
  if (data.promotions) {
    offer = await valueTileOffer(data.promotions[0]);
  }
  let includeRp = false,
    rpPrice = "",
    rpFontSize = "";
  if (!offer) {
    price = await priceChecker(data.price, currency);
    let size = price.length > 3 ? "32px" : price.length < 3 ? "52px" : "48px";
    offer = {
      valueTileTop: `${price}`,
      valueTileTopFont: size,
      ...reset,
    };
  } else {
    includeRp = offer.clubcardPrice;
    if (includeRp) {
      rpPrice = await priceChecker(data.price, currency);
      rpFontSize =
        rpPrice.length > 3 ? "16px" : rpPrice.length < 3 ? "18px" : "17px";
    }
  }
  const img = data.image.replace("90x90", "225x225");
  let tierOne = {
    headline: data.name,
    subhead: "",
    terms: "",
    bannerURL: `https://www.tesco.com/groceries/en-GB/products/${data.id}`,
    valueTileTop: "",
    valueTileTopFont: "",
    valueTileBottom: "",
    valueTileBottomFont: "",
    fontColor: "#FFFFFF",
    bgColor: "#FFFFFF",
    panelColor: "#00539F",
    fiftyfifty: true,
    invertCta: true,
    orientation: "portrait",
    primaryPackshot: {
      path: img,
      name: data.name,
    },
    secondaryPackshot: {
      path: "",
      name: "",
    },
    logo: {
      path: "",
      name: "",
    },
    background: {
      path: "",
      name: "",
    },
    tpnb: data.tpnb,
    includePadding: true,
    includeAsterisk: false,
    decimalPlace: "",
    includeRegularPrice: includeRp,
    regularPricePrice: rpPrice,
    regularPriceFontSize: rpFontSize,
  };
  tierOne = { ...tierOne, ...offer };
  return tierOne;
};

//export const vtChoice = async (value, response) => {
//  let offer = null;
//  if (response.promotions) offer = response.promotions[0];
//  if (response.DeliveryRestrictions) {
//    if (response.DeliveryRestrictions.Message)
//      offer = response.DeliveryRestrictions.Message;
//  }
//  let vt = null;
//  switch (value) {
//    case "save":
//      vt = await toSave(offer);
//      break;
//    case "was":
//      vt = await toWas(offer);
//      break;
//    case "new":
//      vt = await toNew();
//      break;
//    case "ccp":
//      vt = await toCcp(offer);
//      break;
//    case "default":
//      vt = await valueTileOffer(offer);
//      if (!vt) {
//        let price = await priceChecker(response.price);
//        let size = price.length > 2 ? "32px" : "52px";
//        vt = {
//          valueTileTop: `${price}`,
//          valueTileTopFont: size,
//          ...reset,
//        };
//      }
//      break;
//    default:
//      return (vt = await valueTileOffer(offer));
//  }
//  return vt;
//};

export const linkChoice = async (value, response) => {
  const { id } = response;
  const promoId = response.promotions[0].id;
  let url;
  switch (value) {
    case "pdp":
      url = `https://www.tesco.com/groceries/en-GB/products/${id}`;
      break;
    case "offer":
      url = `https://www.tesco.com/groceries/en-GB/promotions/${promoId}`;
      break;
    default:
      return null;
  }
  return { bannerURL: url };
};
